import { getTool, IReport, TOOL_MAP, TTool } from "@highway/mbs-shared";

export const getEventPrefix = (report: IReport, tool: TTool) => {
    const toolInfo = getTool(tool as TTool);
    const isLoanCompare = toolInfo?.tool === TOOL_MAP.loan_compare.tool;
    const isLoanComparePurchase = isLoanCompare && report.toolMeta.type === "purchase";
    const isLoanCompareRefinance = isLoanCompare && report.toolMeta.type === "refinance";
    const isDebtConsolidation = toolInfo?.tool === TOOL_MAP.debt_consolidation.tool;
    const isDebtConsolidationRefinance = isDebtConsolidation && report.toolMeta.type === "refi";
    const isDebtConsolidationMoveUp = isDebtConsolidation && report.toolMeta.type === "moveup";
    const isDebtConsolidationPurchase = isDebtConsolidation && report.toolMeta.type === "purchase";
    return isLoanComparePurchase
        ? "lc_purchase"
        : isLoanCompareRefinance
        ? "lc_refi"
        : isDebtConsolidationRefinance
        ? "dc_refi"
        : isDebtConsolidationMoveUp
        ? "dc_moveup"
        : isDebtConsolidationPurchase
        ? "dc_home_purchase"
        : toolInfo?.eventPrefix || "";
};
